import { Loader, PageTitle } from 'components';
import React, { FC } from 'react';
import connect, { useConnect } from './connect';
import { Loading } from './styles';
import { Props } from './types';

const Impersonate: FC<Props> = ({ impersonate }) => {
  useConnect({ impersonate });

  return (
    <Loading>
      <PageTitle title="Impersonating" />
      <Loader />
    </Loading>
  );
};

export default connect(Impersonate);
